import React from 'react';
import {useHistory} from "react-router-dom";
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import IconDashboard from "@material-ui/icons/Dashboard";
import {useStyles} from '../SideBarStyles.js'

function DashboardItem(props) {

    const {DataStore} = props

    const classes = useStyles()

    let history = useHistory();

    return (
        <List component="nav" className={classes.appMenu} disablePadding>
            <ListItem button className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                    <IconDashboard/>
                </ListItemIcon>
                <ListItemText primary="Dashboard" className={classes.menuItemText}
                              onClick={() => {
                                  DataStore.getTabs('Dashboard')
                                  history.push("/control-panel/dashboard")
                              }}/>
            </ListItem>
        </List>
    )
}

export default DashboardItem
